<template>
<div class="wrapper">
  <!-- Bridge img -->
  <div class="bridge-parent" v-show="structureDetails.type != 'generic'">
    <SensorToggle v-if="structureDetails.type != 'generic'&& sensors && structureDetails" id="sensortoggle-bridge" :sensors="sensors" :selectedSensor="selectedFromParent" @type-selected="this.typeSelected" />
    <!-- Elemento Bridge -->
    <div class="bridge-child">
      <div id="bridge-image" @click="closeModals($event)"></div>
      <!-- Sensor Overlay -->
      <div class="sensors-container">
        <!-- Bottone del sensore -->
        <div
          class="tooltip"
          v-for="sensor in validSensors"
          v-bind:key="sensor.eui"
          width="64px"
          height="64px"
          :style="{
            marginTop: computeMarginTop(sensor) + 'px',
            marginLeft: computeMarginLeft(sensor) + 'px'
          }"
        >
          <button
            v-if="done"
            class="button"
            v-bind:class="[
              isSelected(sensor) ? 'selected-button' : '',
              isTiltMeter(sensor) ? 'tilt-button' : '',
              isAccelerometer(sensor) ? 'tilt-button' : '',
              isCrackMeter(sensor) ? 'crack-button' : ''
            ]"
            @click="selectSensor(sensor); closeModals($event);"
          >
          <span class="sensor-dot" :style="{ backgroundColor: getSensorColor(sensor) }"></span>
          {{ sensor.eui.substr(sensor.eui.length - 5) }}</button>
          <span class="tooltiptext">
            <p>EUI: {{sensor.eui.substr(sensor.eui.length - 5)}}</p>
            <p>Name: {{sensor.userConfig.name}}</p>
            <p>Last Seen: {{sensor.stats ? (sensor.stats.lastTX ? new Date(sensor.stats.lastTX).toLocaleString() : ' - ') : new Date(sensor.lastTX)}}</p>
          </span>
        </div>
      </div>
    </div>
  </div>
  <!-- Immagine generica -->
  <Generic  
    v-show="structureDetails.type === 'generic'"
    :selectedSensorFromParent="selectedSensor"
    :selectedStructure="structureDetails" 
    :editable="false"
    @sensor-selected="selectSensor"
  />
</div>
</template>
<script>
import SensorToggle from '../ui/SensorToggle'
import Generic from "../structures/generic";
import $ from 'jquery'

/*
BridgeDraw ha il compito di plottare l'immagine del ponte, con i relativi sensori sopra.
Emette un evento 'sensor-selected' quando viene selezionato un sensore.
*/
export default {
  name: 'bridge-min',
  components: {
    SensorToggle,
    Generic
  },
  data() {
    return {
      selectedSensor: this.sensors[0],
      temperature: 18,
      isInfoVisible: false,
      isTempInfoVisible: false,
      actualType: 'deck',
      done: false
    }
  },
  props: {
    spans: Number,
    sensors: Array,
    selectedFromParent: Object,
    structureDetails: Object
  },
  methods: {
    computeMarginTop: function (sensor) {
      let marginTop
      marginTop = sensor.bridgeSide * 155 - 255
      return marginTop
    },
    computeMarginLeft: function (sensor) {
      return (sensor.bridgeSpan / 10) * 343 - 290
    },
    isSelected: function (sensor) {
      return this.selectedSensor && this.selectedSensor.eui == sensor.eui
    },
    isTiltMeter: function (sensor) {
      return sensor.type === 'tiltmeter'
    },
    isDeck: function (sensor) {
      return sensor.type === 'deck'
    },
    isCrackMeter: function (sensor) {
      return sensor.type === 'crackmeter'
    },
    isAccelerometer: function (sensor) {
      return sensor.type === 'accelerometer'
    },
    closeModals: function (e) {
      if (!e.target.className || e.target.className != 'info-svg') {
        this.isInfoVisible = false
        this.isTempInfoVisible = false
      }
    },
    showInfo: function () {
      this.isInfoVisible = !this.isInfoVisible
      this.isTempInfoVisible = false
    },
    showTemp: function () {
      this.isTempInfoVisible = !this.isTempInfoVisible
      this.isInfoVisible = false
    },
    selectSensor: function (sensor) {
      this.selectedSensor = sensor
      this.$emit('sensor-selected', this.selectedSensor)
    },
    appendBridgeSection(nSpanes) {
      //img.width = "1280";
      this.done = false;
      let bridgeWrapper = document.getElementById('bridge-image')
      for (let i = 0; i < nSpanes; i++) {
        var img = document.createElement('img')
        img.src = require('../../../public/assets/BridgeChop.png');
        bridgeWrapper.prepend(img)
      }
      this.done = true;
    },
    typeSelected(type) {
      // Se viene selezionato un tipo ed è diverso da quello del sensore attualmente selezionato, seleziono un nuovo sensore
      this.actualType = type
      //if(type != this.selectedFromParent.type)
      this.selectSensor(this.validSensors[0])
    },
    checkIfOnline(sensor) {
      const maxOffset = sensor.type === 'analog-node' ? 65: 35; // Massimo delta ammissibile in minuti
      const diff = Math.abs(new Date() - new Date(sensor.stats.lastTX)); // Differenza in ms. dall'ultima trasmissione
      return Math.floor(diff / 1000 / 60) <= maxOffset;
    },
    getSensorColor(sensor) {
      let color;
      if (this.checkIfOnline(sensor)) {
        color = "green";
      } else {
        color = "red";
      }
      return color;
    },
  },
  computed: {
    validSensors: function () {
      let type = this.actualType
      return this.sensors.filter(function (el) {
        return el.type === type
      })
    },
  },

  watch: {
    sensors: {
      // Quando cambiano i sensori della struttura Seleziono un nuovo sensore e disegno il ponte nuovo
      handler: async function (newValue, oldValue) {
        if (newValue[0].eui != oldValue[0].eui) {
          this.selectSensor(newValue[0])
          let bridgeWrapper = document.getElementById('bridge-image')
          bridgeWrapper.textContent = ''
          this.appendBridgeSection(this.spans)
        }
      },
      deep: true,
    },
  },
  mounted() {
      this.appendBridgeSection(this.spans),
        // Quando clicco sull'immagine aggiungo classe "active"
        $('.bridge-child').mousedown(function () {
          var hovered = $('.tooltip').find('.button:hover').length

          if (hovered < 1) {
            $('.bridge-child').addClass('active')
          }
        })
      // Quando smetto di cliccare la rimuovo
      $('.bridge-child').mouseup(function () {
        $('.bridge-child').removeClass('active')
      })
      // Quando sposto il mouse la rimuovo
      $('.bridge-child').mouseleave(function () {
        $('.bridge-child').removeClass('active')
      })
      // Quando effettuo un win resize riporto il ponte in posizione iniziale
      $(window).resize(function () {
        $('.bridge-child').css('left', '0px')
      })
      // Con doppio click riporto il ponte in posizione iniziale
      $('.bridge-child').dblclick(function () {
        $('.bridge-child').css('left', '0px')
      })
      // Drag handler
      $('.bridge-child').draggable({
        cursor: 'move',
        containment: 'bridge-parent',
        axis: 'x',
        stop: function () {
          let left = $('.bridge-child').position().left
          let width = $('#bridge-image').width()
          if (left > width - 500 || left < -(width - 500)) {
            $('.bridge-child').css('left', '0px')
          }
        },
      })

  },
}
</script>
<style scoped>
.total-overlay {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
.modal-info {
  border-radius: 10px;
  border-style: solid;
  border-width: 2px;
  border-color: rgb(91, 96, 118);
  -webkit-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

#info-deck {
  position: absolute;
  top: -120px;
  left: 460px;
  max-width: 500px;
}

#info-temp {
  position: absolute;
  top: 60px;
  width: 500px;
  left: 80px;
}
.bridge-parent {
  padding-top: 50px;
}
.bridge-child {
  display: grid;
  justify-content: center;
  transition: transform 0.3s;
  transform: scale(1);
  margin-top: 100px;
  margin-bottom: 120px;
}
.bridge-img {
  top: 0;
  left: 0;
  cursor: pointer;
  filter: drop-shadow(rgba(0, 0, 0, 0.5) 1px 7px 4px);
}

#bridge-image {
  display: flex;
}
.bridge-child.active > .bridge-img {
  cursor: grabbing;
  cursor: -webkit-grabbing;
}

.bridge-child.active {
  transform: scale(1.02);
}

#help-tip {
  position: absolute;
  width: 430px;
  top: 180px;
  left: 120px;
  text-align: left;
  display: grid;
}

#temperature {
  position: absolute;
  display: grid;
  width: 205px;
  top: 220px;
  left: 60%;
  text-align: left;
}


@media only screen and (min-width: 1300px) {
  #temperature {
    position: absolute;

    width: 205px;
    top: 220px;
    left: 6 0vw;
    text-align: left;
  }
}

@media only screen and (max-width: 1000px) {
  #temperature {
    position: absolute;
    width: 205px;
    top: 300px;
    left: 120px;
    text-align: left;
  }
}

#sensortoggle-bridge {
  position: absolute;
  top: 267px;
  left: 117px;
  /* width: 778px; */
}

@media all and (max-width: 1799px) and (min-width: 300px) {
  #help-tip {
    left: 30px;
  }

  #sensortoggle-bridge {
    position: absolute;
    top: 240px;
    left: 30px;
    /* width: 600px; */
  }
}

.over-info > h2 {
  grid-row: 1;
  grid-column: 1;
  font-size: 1.2em;
  color: white;
  margin: 0;
}
.over-info > p {
  grid-column: 1;
  grid-row: 2;
  margin: 0;
}
.over-info > img {
  justify-self: end;
  grid-column: 1;
  grid-row: 1;
}

.sensors-container {
  width: 640px;
  top: 0;
  left: 0;
  position: relative;
}

.tooltip {
  font-size: smaller;
  position: absolute;
  display: inline-block;
}

.tooltip .tooltiptext {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0.2s linear, opacity 0.2s linear;
  transition-delay: 0s;
  width: max-content;
  background-color: rgb(31,33,44);
  /* border: solid 2px white; */
  color: #fff;
  text-align: left;
  border-radius: 10px;
  padding: 10px;
  box-sizing: border-box;
  position: absolute;
  z-index: 1;
  bottom: 120%;
  left: 20%;
  margin-left: -7vw;
  font-family: inherit;
}

.tooltiptext p {
  margin: 0;
}

.tooltip:hover > .tooltiptext {
  visibility: visible;
  opacity: 1;
  transition-delay: 0.5s;
}
.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -15px;
  border-width: 15px;
  border-style: solid;
  border-color: rgb(31,33,44) transparent transparent transparent;
}

.button {
  width: 120px;
  height: 36px;
  /* padding: 5px; */
  padding-right: 15px;
  display: flex;
  /* padding: 3px; */
  /* justify-content: space-evenly; */
  align-items: center;
  font-size: 1.2em;
  font-weight: 700;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  outline: none;
  color: #fff;
  background-color: rgb(80, 84, 105);
  border: solid 5px white;
  border-radius: 20px;
  transition: transform 0.1s linear;
}

.selected-button {
  background-color: rgb(35, 145, 254);
}

.button:hover {
  /*   background-color: rgb(47, 112, 177); */
  transition: transform 0.1s linear;
  -ms-transform: scale(1.126) translate3d(0, 0, 0);
  -webkit-transform: scale(1.126) translate3d(0, 0, 0);
  transform: scale(1.126) translate3d(0, 0, 0);
}

.button:active {
  background-color: rgb(47, 112, 177);
  transform: translateY(1px);
}
.sensor-dot {
  position: relative;
  /* left: 12px; */
  height: 12px;
  width: 12px;
  /* padding: 7px; */
  margin: 4px;
  background-color: unset;
  border-radius: 12px;
  display: inline-block;
  border: solid 2px white;
  z-index: 12;
  /*   display:block;
  text-align:center; 
  margin:0 auto; */
}
</style>
